import React from 'react'
import moment from 'moment'
import Row from '../components/Row'
import NoRecordsFound from '../components/NoRecordsFound'

const UnregisteredDevicesList = ({devices, onEdit, onDelete, onSort, sortBy, isSortAsc, isLoading}) => { 
    const headers = [
        {
          key: "identifier",
          name: "Identifier",
          width: 4
        },
        {
          key: "creationTime",
          name: "DateAdded",
          width: 4
        },
        {
          key: "register",
          name: "Register",
          sortable: false,
          width: 2
        },
        {
          key: "delete",
          name: "Delete",
          sortable: false,
          width: 2
        }
    ]

    const arrow =  isSortAsc ? <span className="glyphicon glyphicon-triangle-bottom" title="Active" /> : <span className="glyphicon glyphicon-triangle-top" title="Inactive" />

    const renderTableHeaders = () => {
        return headers.map(({ key, name, width, sortable }) => {
            if (sortable === false) {
                return (
                    <th key={key}>
                        <div className={`text-center table-header col-sm-${width}`}>{name}</div>
                    </th>
                )
            }
    
            return (
                <th key={key}  onClick={() => onSort(key)}>
                    <div className={`text-center table-header table-header-clickable col-sm-${width} flex-center`} >
                        {name} {sortBy === key && arrow }
                    </div>
                </th>
            )
        })
    }

    const renderTableRows = () => {
        if (devices.length) {
            return devices.map(device => {
                const selectedFields = {
                    identifier: device.identifier,
                    creationTime: moment(new Date(device.creationTime)).fromNow(),
                }

                return (
                    <Row
                        key={device._id} 
                        data={selectedFields}
                        onEdit={() => onEdit(device._id)}
                        onDelete={() => onDelete(device)}
                    />
                )
            })
        }

        return <NoRecordsFound />
    }

    return (
        <div className="test-instance-list">
            { isLoading ? <div className="flex-center"><LoadingSpinner /></div> : (
                <table className="table">
                    <thead className="test-instance-details-head">
                    <tr>
                        { renderTableHeaders() }
                    </tr>
                    </thead>
                    <tbody>
                    { renderTableRows() }
                    </tbody>
                </table>
            )}
        </div>
    )
}

export default UnregisteredDevicesList
